import React, { useEffect, useRef, useState } from "react";
import "croppie/croppie.css";
import { Avatar, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import styled from "styled-components";
import docIcon from "./FiletypeIcons/doc.svg";
import jpgIcon from "./FiletypeIcons/jpg.svg";
import mpIcon from "./FiletypeIcons/mp.svg";
import pngIcon from "./FiletypeIcons/png.svg";
import svgIcon from "./FiletypeIcons/svg.svg";
import txtIcon from "./FiletypeIcons/txt.svg";
import xlsIcon from "./FiletypeIcons/xls.svg";
import pdfIcon from "./FiletypeIcons/pdf.svg";
import pptIcon from "./FiletypeIcons/ppt.svg";
import { observer } from "mobx-react-lite";
import { usePrevious } from "../../helpers/usePrevious";
import { deepClone, toCamelCase } from "../../helpers/objectHelper";
import Axios from "axios";
import FolderIcon from "@material-ui/icons/Folder";
import EventLabel from "../../components/EventLabel";
const FileIcon = styled.img`
  width: 50px;
  maxwidth: 50px;
  max-height: 50px;
  height: auto;
`;

export const FileUploader = observer((props) => {
  const [source, setSource] = useState("");
  const [sourceFilename, setSourceFilename] = useState("");
  const [sourceType, setSourceType] = useState("");
  const [showConflictPopper, setShowConflictPopper] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [fileUploadTriggered, setFileUploadTriggered] = useState(false);
  const fileInputRef = useRef(null);
  const prevProps = usePrevious(props);

  const { activePersonNo, orders, contentLayout, updateOrder, allowedFiletypes, environment } = props;

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  useEffect(() => {
    if (orders && prevProps && orders[activePersonNo]?.uploadedFiles?.length != prevProps.orders[prevProps.activePersonNo]?.uploadedFiles?.length) {
      setUploading(false);
    }
  });
  useEffect(() => {
    if (fileUploadTriggered) {
      setFileOnOrder();
      setFileUploadTriggered(false);
    }
  }, [fileUploadTriggered]);

  const onFileSelected = async (e) => {
    const file = e.target.files[0];
    if(!orders[activePersonNo]){
      updateOrder({});
    }
    const order = orders[activePersonNo];
    const key = order.sqlStateNo;

    const hasNameConflict = order[toCamelCase("UploadedFiles")]?.find((u) => u.name?.replace(`${key}_`, "") == file?.name);

    if (hasNameConflict) return setShowConflictPopper(true);

    const result = await toBase64(file).catch((e) => Error(e));

    if (result instanceof Error) {
      /*      this.setState({ errorMessage: result.message }); */
      return;
    }
    if (orders) {
      let order = orders[activePersonNo];
      if (!order.sqlStateNo || order.sqlStateNo != contentLayout.sqlStateNo) updateOrder(order);
    }
    setSource(result);
    setSourceType(file.type);
    setSourceFilename(file.name);
    setShowConflictPopper(false);

    setFileUploadTriggered(true);
    /*    setTimeout(() => setFileOnOrder(), 1000); */
  };

  const setFileOnOrder = () => {
    if (orders) {
      let order = orders[activePersonNo];
      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase("UploadedFiles")];
      let newType = undefined;
      if (!type) {
        newType = [];
      } else {
        newType = deepClone(type);
      }

      setUploading(true);

      Axios.post(`./api/files/fileUploadTemp/${environment.eventId}`, {
        file: source,
        name: `${order.sqlStateNo + "_" + activePersonNo}_${sourceFilename}`,
        type: sourceType,
      }).then(({ data }) => {
        newType.unshift(data);
        newOrder[toCamelCase("UploadedFiles")] = newType;

        updateOrder(newOrder);

        setSource("");
        setSourceType("");
        setSourceFilename("");

        setUploading(false);

        if (fileInputRef) fileInputRef.current.value = "";
      });
    }
  };

  const removeUploadedFile = (file) => {
    if (orders) {
      let order = orders[activePersonNo];
      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase("UploadedFiles")];
      let newType = type.filter((f) => f.url !== file.url);
      newOrder[toCamelCase("UploadedFiles")] = newType;

      updateOrder(newOrder);

      Axios.post(`./api/files/removeUploadedFile/${order.eventId}`, file);
    }
    setDeleteTarget(null);
  };

  const confirmDelete = (confirmed) => {
    if (confirmed == true && deleteTarget) {
      removeUploadedFile(deleteTarget);
      setShowDeleteDialog(false);
    } else {
      setShowDeleteDialog(false);
      setDeleteTarget(null);
    }
  };

  let order = null;
  if (orders) {
    order = orders[activePersonNo];
  }

  const key = order ? order.badgeNo || order.sqlStateNo : "";

  return (
    <div className="w-100 text-center" style={{ padding: 7 }}>
      <div style={{ display: "flex" }}>
        <div style={{ width: "50%", padding: "6px", border: "1px dashed gainsboro", borderRadius: 5, background: "rgba(238, 238, 238, 0.2)", display: "flex", alignItems: "center" }}>
          <label htmlFor="file-upload" className="cms-button upload" style={{ marginRight: 10, cursor: "pointer" }}>
            <FolderIcon />
            <EventLabel name="SelectFile" groupName="Cms.FileUpload" />

          </label>
          <caption className="file-uploader text ellipsis">{source ? sourceFilename.replace(`${key}_`, "") : <EventLabel name="NoFileChosen" groupName="Cms.FileUpload" />}</caption>
        </div>
        <input ref={fileInputRef} style={{ display: "none" }} className="form-control" type="file" id="file-upload" accept={allowedFiletypes?.join("")} onChange={(e) => onFileSelected(e)} />
        {/*      <IconButton disabled={!this.state.source} onClick={this.setFileOnOrder}>
          <PublishIcon />
        </IconButton> */}
      </div>
      {showConflictPopper ? (
        <>
          <br />
          <Alert style={{ textAlign: "left" }} severity="error">
            <AlertTitle>
              <EventLabel name="FileNameConflict" groupName="Cms.FileUpload" />

            </AlertTitle>
            <EventLabel name="FileWithSameNameAlreadyUploaded" groupName="Cms.FileUpload" />

          </Alert>
        </>
      ) : null}

      {uploading ? <LinearProgress /> : <br />}
      {showDeleteDialog && deleteTarget ? <ConfirmDialog action={confirmDelete} /> : null}
      <List dense={false} className="jir-scroll" style={{ maxHeight: 400, overflowY: "auto" }}>
        {order && order[toCamelCase("UploadedFiles")]
          ? order[toCamelCase("UploadedFiles")].map((f, i) => {
            return (
              <ListItem key={f.url} style={{ border: "1px solid #dedede", borderRadius: "5px", background: "#ffffff", marginBottom: 3 }}>
                <ListItemAvatar>
                  <Avatar style={{ background: "transparent", borderRadius: 5, position: "relative" }}>
                    <FileType type={f.name.substr(f.name.lastIndexOf(".") + 1, f.name.length)} source={f.url} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={
                    <p style={{ margin: 0 }} className="file-uploader text ellipsis">
                      {f.name.includes(`${order.sqlStateNo}_${activePersonNo}_`) ? f.name.replace(`${order.sqlStateNo}_${activePersonNo}_`, "") : f.name.replace(`${key}_`, "")}
                    </p>
                  }
                />
                <ListItemSecondaryAction>
                  <IconButton
                    onClick={() => {
                      setShowDeleteDialog(true);
                      setDeleteTarget(f);
                    }}
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            );
          })
          : null}
      </List>
    </div>
  );
});

const FileType = ({ type, source }) => {
  switch (type) {
    case "pdf":
      return <FileIcon src={pdfIcon} />;
    case "doc":
    case "docx":
      return <FileIcon src={docIcon} />;
    case "jpg":
      return <FileIcon src={source || jpgIcon} />;
    case "gif":
    case "jif":
      return <FileIcon src={source} />;
    case "mp4":
      return <FileIcon src={mpIcon} />;
    case "png":
      return <FileIcon src={source || pngIcon} />;
    case "svg":
      return <FileIcon src={svgIcon} />;
    case "txt":
      return <FileIcon src={txtIcon} />;
    case "xls":
    case "xlsx":
      return <FileIcon src={xlsIcon} />;
    case "ppt":
    case "pptx":
      return <FileIcon src={pptIcon} />;
    default:
      return null;
  }
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function ConfirmDialog({ action }) {
  return (
    <div>
      <Dialog open={true} TransitionComponent={Transition} keepMounted onClose={action} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">
          <EventLabel name="DeleteFile" groupName="Cms.FileUpload" />
        </DialogTitle>
        <DialogContent style={{ width: 350 }}>
          <DialogContentText id="alert-dialog-slide-description">
            <EventLabel name="FileDeletePerm" groupName="Cms.FileUpload" />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={action} color="default">
            <EventLabel name="Cancel" groupName="Cms.FileUpload" />
          </Button>
          <Button onClick={() => action(true)} variant="contained" style={{ background: "rgb(223, 65, 54)", color: "#fff", boxShadow: "none" }}>
            <EventLabel name="DeleteConfirm" groupName="Cms.FileUpload" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
